import { ThemeProvider } from 'styled-components'
import klouserSkin from '../../skins/main'
import customSkin from '../../skins/custom'
import GlobalStyles from '../../GlobalStyles'
import { useMemo } from 'react'
import { connect } from 'react-redux'
import { Group } from '../../../../types'

interface ComponentProps {
  children: any
  group: Group,
  postGroup: Group | null,
}

const Component = ({ group, postGroup, children }: ComponentProps) => {
  // When the user lands directly on a post preview (F5/deeplink), groupStore
  // is empty — the group data is only nested inside postStore.post. Fall back
  // to that so the creator's primary_color is applied on first paint instead
  // of waiting for a group navigation to populate groupStore.
  const effectiveGroup = group || postGroup;

  const skin = useMemo(() => {
    const primary = effectiveGroup?.expert?.primary_color;
    const secondary = effectiveGroup?.expert?.secondary_color || effectiveGroup?.expert?.primary_color;
    const logoBig = effectiveGroup?.expert?.big_logo?.url;
    const logoSmall = effectiveGroup?.expert?.small_logo?.url;

    return {
      ...klouserSkin,
      ...(!!primary || !!secondary ? {
        colors: customSkin.colors({ primary, secondary }),
        form: customSkin.form({ primary, secondary }),
        button: {
          ...klouserSkin.button,
          colors: { ...customSkin.button.colors },
        },
        link: {
          ...klouserSkin.link,
          colors: { ...customSkin.link.colors },
        },
        bullet: {
          ...klouserSkin.bullet,
          color: customSkin.bullet({ primary, secondary }).color,
        },
        footer: customSkin.footer({ primary, secondary }),
        howItsWorks: customSkin.howItsWorks({ primary, secondary }),
      } : {}),
      logo: {
        big: !!logoBig ? logoBig : klouserSkin?.logo?.big,
        small: !!logoSmall ? logoSmall : klouserSkin?.logo?.small
      }
    }
  }, [effectiveGroup])


  return (
    <ThemeProvider theme={skin}>
      <GlobalStyles />
      {children}
    </ThemeProvider>
  )
}

const state = ({ groupStore, postStore }) => {
  const { data: group } = groupStore.group;
  const { data: post } = postStore.post;

  return { group, postGroup: post?.group || null };
};

export default connect(state)(Component);
